import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  constructor() { }

  public openModal() {
    let modal = document.getElementById('modal');
    let fade = document.getElementById('fade');
    if (modal && fade) {
      modal.style.display = 'block';
      modal.style.left = (window.innerWidth - 200) / 2 + 'px';
      fade.style.display = 'block';
    }
  }

  public closeModal() {
    let modal = document.getElementById('modal');
    let fade = document.getElementById('fade');
    if (modal && fade) {
      modal.style.display = 'none';
      fade.style.display = 'none';
    }
  }
}
